import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import UserRouteController from "components/pages/route-controller/route-manager";
import GenericError from "components/common/error-page/error-page";

const App = () => {
  return (
    <>
      <Switch>
        {/*<Route*/}
        {/*  path="/issue/:brand/audioproduct/standard/:issue/view/online"*/}
        {/*  component={UserRouteController}*/}
        {/*/>*/}
        {/*<Route*/}
        {/*  path="/eaudio/:brand/audioproduct/standard/:issue/static/view/online/:token"*/}
        {/*  component={UserRouteController}*/}
        {/*/>*/}
        <Redirect
          from={"/plus-player/:brand/:variant/:issue/view/online"}
          to={"/plus-player/:brand/:variant/:issue/view/online/0"}
          exact
        />
        <Route
          path="/plus-player/:brand/:variant/:issue/view/online/:token"
          component={UserRouteController}
        />

        <Route path="*" component={GenericError} />
      </Switch>
    </>
  );
};

export default App;
